// extracted by mini-css-extract-plugin
export default {"text":"FormatProfileField_text__URlsM","breakWord":"FormatProfileField_breakWord__9Zilt","expandButton":"FormatProfileField_expandButton__WanKN"};